import React from 'react'
import { List, Header, Icon } from 'semantic-ui-react'

const Directions = () => (
    <React.Fragment>
        {/* <List>
            <List.Item icon='users' content='Semantic UI' />
            <List.Item icon='marker' content='New York, NY' />
            <List.Item
                icon='mail'
                content={<a href='mailto:jack@semantic-ui.com'>jack@semantic-ui.com</a>}
            />
            <List.Item
                icon='linkify'
                content={<a href='http://www.semantic-ui.com'>semantic-ui.com</a>}
            />
        </List> */}


        {/* <Header style={{ textAlign: "auto" }} >Healthcare Brief and X-Ray File Upload</Header> */}
        <Header style={{ textAlign: "center" }}> Create a Draft Project Directions</Header>
        {/* <p style={{ textAlign: "auto" }}> <Icon sname= "form" /> </p> */}
        <p style={{ textAlign: "auto" }}> <Icon name='wpforms' />Fill in Draft Form</p>
        <p style={{ textAlign: "auto" }}> <Icon name= "users" />Add members in your organization for peer review</p>
        <p style={{ textAlign: "auto" }}> <Icon name='image' />Upload Xray Chest Images</p>
    </React.Fragment>
)

export default Directions

